<template>
    <div class="line" :class="{'wide': wide && wide === true, 'align-center': alignCenter}">
        <div class="line__title">
            <div v-html="title" />
            <slot name="newline" class="line__newline" />
        </div>
        <div class="line__value type" v-if="value && value !== null" :class="'type-' + type">
            <span v-if="value === false">Nej</span>
            <span v-if="value === true">Ja</span>
            <span v-if="value !== true && value !== false && value !== 'donotshow'">
                <span v-html="value" />
                <span v-if="suffix" v-html="suffix" />
            </span>
            <slot name="extra" />
        </div>
        <div class="line__value" v-else>
            -
        </div>
    </div>
</template>

<style lang="scss" scoped>

    .line {
        flex-wrap: wrap;

        &.big-text {
            font-size: 20px;
        }

        &.align-center {
            align-items: center;
        }

        &__value {

            &:first-letter {
                text-transform: uppercase;
            }

            &.type {
                position: relative;

                &:before {
                    height: 100%;
                    text-align: right;
                    position: absolute;
                    content: "";
                    display: flex;
                    align-items: center;
                    top: 0;
                    right: 15px;
                    z-index: 1000;
                    opacity: .5;
                    font-weight: 400;
                }

                &.type-km:before {
                    content: "km";
                }

                &.type-kr:before {
                    content: 'kr.'
                }
            }
        }

        &__newline {
            flex: 0 0 100%;
        }
    }

</style>


<script>
export default {
    props: [
        'title',
        'value',
        'suffix',
        'wide',
        'alignCenter',
        'type'
    ]
}
</script>



// WEBPACK FOOTER //
// line-data.vue?25a443d1